<script>
import { onMount } from 'svelte';
onMount(async () => {
	//document.querySelector('input[type=image]').click()
});

let curArtistName = '';
let tree = []
th.tree = tree;

function onSubmit(e) {
	const formData = new FormData(e.target);
	const data = {};
	for (let field of formData) {
		const [key, value] = field;
		data[key] = value;
	}
	
	let tmpTree = [];
	curArtistName = data.artist;
	th.api.artist.info(data.artist).then(json => {
		tmpTree.unshift(th.newNode(data.artist, 1, {info: json.artist}))
	})

	th.api.artist.similar(data.artist).then(function(json) {
		json.similarartists.artist.forEach(artist => {
			tmpTree.push(th.newNode(artist.name, 1, {info: artist}));
		});

		tree = tmpTree;
		console.log('TREE: ', tree)
		//console.log('ITER: ', Object.keys(tree[curArtistName]['similar']))
	})
}

function onArtistClick(artist) {
	let tmpTree = [];
	th.api.artist.albums(artist.name).then(function(json) {
		json.topalbums.album.forEach(album => {
			tmpTree.push(th.newNode(album.name, 2, {image: album.image}));
		});
		artist.data.albums = tmpTree;
		tree = tree;
		console.log('TREE: ', tree);
	})
}

function onAlbumClick(artist, album) {
	let tmpTree = [];
	th.api.album.info(artist.name, album.name).then(function(json) {
		json.album.tracks.track.forEach(track => {
			console.log(track);
			tmpTree.push(th.newNode(track.name, 3, {duration: track.duration}));
		});
//		album.data.info = json.album.wiki;
		album.data.tracks = tmpTree;
		tree = tree;
		console.log(tree)
		//tracks[albums[artist]] = json.topalbums.album
	})
}

</script>

<header>
	<form action="" method="post" on:submit|preventDefault={onSubmit}>
		<a class="logo" href="#">☰</a>
		<input name="artist" autofocus value="Rammstein" type="text" placeholder="Type artist name:" />
		<input name="method" type="hidden" value="artist.getSimilar" />
		<!-- <input type="submit" value="GO" /> -->
		<input type="image" src="../logo.svg" alt="Search">
	</form>
</header>

<article>
	{#if !tree.length}
	<div class="centered">
	<div class="intro typo">
		<h2>
			Track<strong>hunter</strong>
			<em>for those who love the music</em>
		</h2>
		<p>Convenient search for similar artists and tracks, viewing biography and discography of musical projects, listening to tracks when authorizing through VK.com</p>
		<ul>
			<li>Enter the name of the artist in the field above.</li>
			<li>Start the search for any artist from the list by clicking the arrow.</li>
			<li>When you click on a track from the album, recommendations will appear.</li>
		</ul>
		<a class="vk" href="#">
			<img src="../vk.png">
		</a>
	</div>
	</div>
	{/if}	
	<ul class="artists">
	{#each tree as artist}
		<li>
			<a href="#" name={artist.name} on:click|preventDefault|stopPropagation={onArtistClick(artist)}>{artist.name}</a>
			<ul class="artist-actions">
				<li><button>≡</button></li>
				<li><button>ⓘ</button></li>
				<li><button>♡</button></li>
				<li><button>➜</button></li>
			</ul>
			<!-- <button>▶</button> -->
			<ul class="albums">
				{#if artist.data.albums?.length}
				{#each artist.data.albums as album}
					<li>
						<a href="#" name={artist.name + ' - ' + album.name} on:click|preventDefault|stopPropagation={onAlbumClick(artist, album)}><figure><img src="{album.data.image[1]['#text']}" alt="" /><figcaption>{album.name}</figcaption></figure></a>
						<ul class="tracks">
							{#if album.data.tracks?.length}
							{#each album.data.tracks as track}
							<li><a href="#">{track.name} <em>{th.fmtMMSS(track.data.duration)}</em></a></li>
							{/each}
							{/if}
						</ul>
					</li>
				{/each}
				{/if}
			</ul>
		</li>
	{/each}
	</ul>
</article>

<style lang="scss">
@import "../base/_config.scss";

article {height:100%; padding-top:36px;}
article .centered {height:100%;}

.intro {max-width:680px; background: rgba(255,255,255,0.75); margin: 0 24px; border-radius:16px; padding:16px; font-size:16px;}
.intro h2 {color:#fff; font-size:28px; font: bold 28px Arial; background: #000; display:block; text-align: center; border-radius: 16px; padding:24px 16px 24px 8px; margin-bottom:16px}
.intro h2 strong {color:#000; display:inline-block; background: #ff9800; border-radius: 8px; padding: 0 8px; margin-left:8px;}
.intro h2 img {vertical-align:baseline; height:20px}
.intro li {line-height: 1.2; margin-bottom:8px; padding-left: 12px; font-weight: bold;;}
.intro li:before {content: "-"; position:absolute; margin-left: -12px; }
.intro p {line-height: 1.2; margin-bottom:16px;}
.intro h2 em {display: block; font:normal 14px Arial; color:#ccc; margin-top:16px; text-shadow: #fff 0px 0px 10px, 0 0 32px #fff;}

.vk {margin-top:16px; display:block; text-align: center;}

// header img {vertical-align:top; height:18px; margin-top: 8px; margin-left:8px;}
header .logo {display:inline-block; color:#fff; text-decoration:none; font-size:24px; vertical-align:top; background: rgba(0,0,0,0.51); padding:0px 12px 0px 12px; border-right:1px solid #444}
header {height:36px; background: rgba(0,0,0,0.75); color:#fff; position: fixed; z-index:1; left:0; right:0;}
header input {background:transparent; outline:0; font-size:16px; border:0; color:#fff; padding:0px 8px; line-height:36px;}
header input[type="text"] {width:calc(100% - 80px)}
header input[type="image"] {background:rgba(0,0,0,0.5); position:absolute; right:0; top:0; height:36px; padding:9px; border-left:1px solid #444}
::placeholder {
  color: #ccc;
}

.artists > li {outline:1px solid rgba(0,0,0,0.125); position:relative; padding-bottom:8px; background: rgba(0,0,0,0.5)}
.artists > li > a {text-shadow: #000 8px 4px 10px; text-decoration:none; font-size:20px; line-height:24px; display:block; color:#fff; padding:8px 8px 0px 16px;}


.artist-actions {margin-left:12px;  margin-top:8px}
.artist-actions li {outline:none; display: inline-block;  text-align: center; margin-right:4px;}
.artist-actions li > button {background: rgba(0,0,0,0.5); color:#8c8; border:4px solid rgba(0,0,0,0.5); border-radius: 50%; width:32px; height:32px; line-height:25px; font-weight: bold; font-size:20px; text-align: center}
.artist-actions li:last-child {float:right; margin-right:12px;}
// .artist-actions li:last-child button {color:#ffbe5d;}
.artist-actions li:last-child button {color:rgba(255,255,255,0.75); background: rgba(255,255,255,0.1); border:4px inset rgba(255,255,255,0.15);}
.artist-actions li:last-child button:hover {color:rgba(255,255,255,1); background: rgba(255,255,255,0.25); border:4px inset rgba(255, 255, 255, 0.75);}
.artist-actions li:first-child button {font-size:20px;}


// .artists > li {outline:1px solid #999; position:relative; margin-bottom:0px; padding-bottom:4px; background: rgba(0,0,0,0.25);}
/*
header {height:36px; background: rgba(0,0,0,0.5); color:#fff;}
header input {background:#999; border:0; outline:1px solid #ddd; color:#fff; padding:8px 8px; width:49%}
// article {background: #eee;}
.artists > li {outline:1px solid #999; position:relative;  margin-bottom:0px; padding-bottom:4px; background: #444;}
.artists > li a {text-decoration:none; color: #444; font-size:16px; line-height:24px; display:block; background: #666;}
.artists > li > a {text-decoration:none; color: #ddd; font-size:18px; line-height:24px; display:block; background: #444; padding:8px 8px 0px 8px}
.artists > li > a:focus {background:#666; outline:none; color: #ddd;}
// .artists > li > a:before {content:'ⓘ'; vertical-align:middle; display:inline-block; width:32px; height:32px; text-align:center; font:bold 20px/32px Arial; position:absolute; left:0; top:0; color:#aaa;}
.artists > li button {line-height:24px; width:24px; height:24px; text-align:center; background:#666; color: #aaa;}
.artists figure {display:flex;}
// .artists img {height:64px; width: 64px}
.artists img, .artists figcaption {margin-right:16px}
.artists img {align-self: flex-start; min-width:64px;}
.artists h2 {align-self: center; font:normal 16px Verdana;}
.artists li a:hover {background: #ddd}

.artist-actions {margin-left:4px; margin-bottom:8px; margin-top:8px}
.artist-actions li {display: inline-block;  text-align: center; margin-right:4px}
.artist-actions li > button { border:4px inset rgba(0,0,0,0.2); border-radius: 50%; width:32px; height:32px; font-weight: bold; font-size:20px; text-align: center}
.artist-actions li:last-child {float:right; margin-right:8px;}
.artist-actions li:first-child button {font-size:20px}
.artist-actions li:nth-child(3) button {}

// .albums > li {margin-left: 32px;}
// .albums > li > a:before {content:''; position: absolute; top:0; left:0; margin-left:-16px; bottom:0; width:1px; background: #ccc;}
// .albums > li > a:after {content:''; position: absolute; top:32px; left:0; margin-left:-16px; width:16px; height:1px; background: #ccc;}
.albums > li img {outline: 1px solid #ccc}

.tracks li:last-child:after {content: ''; display:block; height:64px;}
.tracks li a {padding: 4px 16px; min-height: 32px; background: #555; color:#fff;}
.tracks li a em {float:right}
.tracks li a:hover {color:#000;}
*/
</style>